import { render, staticRenderFns } from "./choiceCards.vue?vue&type=template&id=00a999be&scoped=true"
import script from "./choiceCards.vue?vue&type=script&lang=js"
export * from "./choiceCards.vue?vue&type=script&lang=js"
import style0 from "./choiceCards.vue?vue&type=style&index=0&id=00a999be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a999be",
  null
  
)

export default component.exports